import React from 'react'
import { NavLink } from 'react-router-dom'
import { AnalyticsFiltersProvider } from '@/contexts/AnalyticsFiltersContext'
import { AnalyticsFiltersBar, FilterBarVariant } from './AnalyticsFiltersBar'
import { ActiveFilterChips } from './ActiveFilterChips'

interface Props {
  children: React.ReactNode
  /** Filter bar variant — controls which filters are shown */
  filterVariant?: FilterBarVariant
}

/**
 * Shared wrapper for all /analytics/* sub-pages. Provides the filter context,
 * sub-navigation bar, and the global filter UI. Children render inside the
 * contextual filter provider so their `useAnalyticsQuery` calls pick up the URL-backed filters.
 */
const SUB_NAV = [
  { to: '/analytics', label: 'Overview', end: true },
  { to: '/analytics/market', label: 'Market' },
  { to: '/analytics/pipeline', label: 'Pipeline' },
  { to: '/analytics/developers', label: 'Developers' },
  { to: '/analytics/brokers', label: 'Brokers' },
  { to: '/analytics/architects', label: 'Architects' },
  { to: '/analytics/comparables', label: 'Comparables' },
]

export function AnalyticsLayout({ children, filterVariant = 'full' }: Props) {
  return (
    <AnalyticsFiltersProvider>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-semibold text-secondary-900">Analytics</h1>
          <nav className="flex gap-2">
            {SUB_NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-600 text-white'
                      : 'text-secondary-600 hover:bg-secondary-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <AnalyticsFiltersBar variant={filterVariant} />
        <ActiveFilterChips />

        {children}
      </div>
    </AnalyticsFiltersProvider>
  )
}
